import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UserData } from 'apps/idl/src/model';
import { ITerminalInfo } from 'apps/idl/src/modules/olaqin/models/iterminal-info';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { PlatformService } from 'apps/idl/src/services/security';
import { CapacitorPluginScePlugin, StatusSCEPlugin } from 'capacitor-plugin-sce';
import { EMPTY, from } from 'rxjs';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { SceFactory } from '../../../../sce4Mobile/sceFactory';
import { EDeviceType } from '../../../enums/EDeviceType';
import { EModule } from '../../../enums/EModule';
import { DrawerPopoverService } from '../../../services/drawer-popover.service';
import { LoaderService } from '../../../services/loader.service';
import { PanneauService } from '../../../services/panneau.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { ConfirmationDossierPatientComponent } from '../../confirmation-dossier-patient/confirmation-dossier-patient.component';
import { PanneauDossierPatientSuccesComponent } from '../panneau-dossier-patient-succes/panneau-dossier-patient-succes.component';

@Component({
  templateUrl: './panneau-correspondances-patients.component.html',
  styleUrls: ['./panneau-correspondances-patients.component.scss'],
})
export class PanneauCorrespondancesPatientsComponent extends DestroyableComponentBase implements OnDestroy{

  @Input() public patientCV: IPatient;
  @Input() public terminal: ITerminalInfo;
  @Input() public correspondancesPatient: IPatient[];
  @Input() public createNewPatient: Function;
  @Input() public mapScorePatients: Map<string, { pertinence: number, distance: number }>;
  public selectedPatient: IPatient | null = null;

  constructor(
    private svcPatients: PatientsService,
    private svcDrawerPopover: DrawerPopoverService,
    private svcLoader: LoaderService,
    private svcPanneau: PanneauService,
    private svcSnackbar: SnackbarService,
    private svcApp : PlatformService,
    private cdr: ChangeDetectorRef,
		private svcPlatform : PlatformService
  ) { 
    super();
		const deviceTypeUser: EDeviceType = this.svcPlatform.getDeviceType();
		this.pluginSce = SceFactory.getSceInstance(deviceTypeUser)
  }

	public pluginSce : CapacitorPluginScePlugin;
	

  public override ngOnDestroy() {
    if (UserData.modules.includes(EModule.sce) && this.svcApp.isMobileApp) {
      from(this.pluginSce.getStatus()).pipe(
        switchMap((status: StatusSCEPlugin) => {
        if (status.connected) {
          return from(this.pluginSce.disconnect());
        }
        return EMPTY;
        })
      ).subscribe(); 
    }
    super.ngOnDestroy();
  }

  public onSelectPatient(patient: IPatient): void {
    this.selectedPatient = patient;
    this.cdr.detectChanges();
  }

  public selectCorrespondance(): void {
    this.svcDrawerPopover.open(
      "Confirmer le choix du patient",
      "auto",
      event.currentTarget,
      ConfirmationDossierPatientComponent,
      {
        confirm: () => {
          this.svcDrawerPopover.close();
          this.svcLoader.showLoader("Enregistrement des données");
          this.svcPatients.updatePatientFromCV(this.selectedPatient, this.patientCV, this.terminal).pipe(
            tap((patient: IPatient) => {
              this.svcLoader.hideLoader();
              this.svcPanneau.open('Lecture carte Vitale', PanneauDossierPatientSuccesComponent, { patient: patient });
            }),
            catchError(() => {
              this.svcLoader.hideLoader();
              this.svcSnackbar.showToast("error", "bottom center", "Une erreur s'est produite veuillez réessayer.", null, null, null, "7000");
              this.svcPanneau.close();
              return EMPTY;
            })
          ).subscribe();
        },
        cancel: () => {
          this.svcDrawerPopover.close();
        },
      }
    );
  }

  public onCreatePatient(patient: IPatient): void {
    if (this.createNewPatient) {
      this.svcLoader.showLoader("Enregistrement des données");
      this.createNewPatient(patient).pipe(
        tap((patient: IPatient) => {
          this.svcLoader.hideLoader();
          this.svcPanneau.open('Lecture carte Vitale', PanneauDossierPatientSuccesComponent, { patient: patient, nouveauPatient: true });
        })
      ).subscribe();
    }
  }
}
